export const NODE_ID_KEYS = {
	APP: 'lift-app',
	HEADER: 'lift-header',
} as const;
